import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { API } from "../../helper/Api";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";


const ListStores = () => {
  const navigate = useNavigate();
  const goToEdittStoreData = (StoreNbr) => {
    navigate("/edittstoredata", {
      state: { StoreNbr }, // data passed via POST-like behavior
    });
  };
    const [storeData, setStoreData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    
    
  
    useEffect(() => {

      const successMessage = sessionStorage.getItem("successMessage");
  
      if (successMessage) {
        toast.success(successMessage, {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
        sessionStorage.removeItem("successMessage");
      }

        const fetchStores = async () => {
          try {
            const response = await API.storeSetting("listtstoredata");
            console.log("Store response:", response);
            // exit;
            setStoreData(response.data);  
            setFilteredData(response.data);
          } catch (error) {
            console.error("Error fetching store data:", error);
          }
        };
      
        fetchStores();
      }, []);

      const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
      
        const filtered = storeData.filter((store) =>
          Object.values(store).some(
            (field) => field && field.toString().toLowerCase().includes(value)
          )
        );
      
        setFilteredData(filtered);
      };

      const columns = [
        { name: "StoreNbr", selector: (row) => row.StoreNbr, sortable: true, width: "180px"},
        { name: "StoreShortName", selector: (row) => row.StoreShortName, sortable: true, width: "180px"},
        { name: "StoreStatus", selector: (row) => row.StoreStatus, sortable: true, width: "180px"},
        { name: "StoreCity", selector: (row) => row.StoreCity, sortable: true, width: "180px"},
        { name: "StoreState", selector: (row) => row.StoreState, sortable: true, width: "180px"},
        { name: "sourceTenantId", selector: (row) => row.sourceTenantId, sortable: true, width: "180px"},
        {
        name: "Actions",
        cell: (row) => (
          <div>
            <button
              // to={`/editstores/${row.corporatestorenbr}`}
              onClick={() => goToEdittStoreData(row.StoreNbr)}
              style={{
                backgroundColor: "#c2fbd7",
                borderRadius: "100px",
                boxShadow:
                  "rgba(44, 187, 99, 0.2) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.15) 0 1px 2px, rgba(44, 187, 99, 0.15) 0 2px 4px, rgba(44, 187, 99, 0.15) 0 4px 8px, rgba(44, 187, 99, 0.15) 0 8px 16px, rgba(44, 187, 99, 0.15) 0 16px 32px",
                color: "green",
                cursor: "pointer",
                display: "inline-block",
                fontFamily: "CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif",
                padding: "7px 20px",
                textAlign: "center",
                textDecoration: "none",
                transition: "all 250ms",
                border: "0",
                fontSize: "14px",
                userSelect: "none",
              }}
              onMouseEnter={(e) => {
                e.target.style.boxShadow =
                  "rgba(44,187,99,.35) 0 -25px 18px -14px inset, rgba(44,187,99,.25) 0 1px 2px, rgba(44,187,99,.25) 0 2px 4px, rgba(44,187,99,.25) 0 4px 8px, rgba(44,187,99,.25) 0 8px 16px, rgba(44,187,99,.25) 0 16px 32px";
                e.target.style.transform = "scale(1.05) rotate(-1deg)";
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow =
                  "rgba(44, 187, 99, 0.2) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.15) 0 1px 2px, rgba(44, 187, 99, 0.15) 0 2px 4px, rgba(44, 187, 99, 0.15) 0 4px 8px, rgba(44, 187, 99, 0.15) 0 8px 16px, rgba(44, 187, 99, 0.15) 0 16px 32px";
                e.target.style.transform = "none";
              }}
            >
              Edit
            </button>
          </div>
        ), width: "100px"
      }
      ];

      return (
    <div className="container-fluid page-body-wrapper">
      <div className="main-panel">
        <div className="content-wrapper">
          <ToastContainer
                                          position="top-center"
                                          autoClose={500}
                                          hideProgressBar={false}
                                          newestOnTop={false}
                                          closeOnClick
                                          rtl={false}
                                          pauseOnFocusLoss
                                          draggable
                                          pauseOnHover
                                          theme="colored"
                                        />
          <div className="container mainbody1" style={{ maxWidth: '1900px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 className="form-header">Store List</h2>
              <Link to="/addtstoredata" className="btn btn-success btn-sm one" style={{ marginRight: "-885px" }}>Add tStoreData</Link>
              <Link to="/addstores" className="btn btn-success btn-sm">Add Store</Link>
            </div>
            <div className="form-group my-3">
            <input
                type="text"
                placeholder="Search stores..."
                value={searchTerm}
                onChange={handleSearch}
                className="form-control"
            />
            </div>

            
            {/* Data Table */}
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              responsive
              noDataComponent="No stores found."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListStores;
